/** Cash Signals: who owes the company money, instalments, and the cheques
 *  (backend/chainlit/cash_engine.py). The shell is EnginePage; the body is
 *  the rich layout: the figures strip, the customers table with the picked
 *  customer's card and the cheque lines beside it, then the sections. */
import { useState } from 'react';

import {
  ChequesCard,
  CustomerCard,
  CustomersTable
} from '@/components/engine/CashRich';
import EnginePage, { SectionsGrid } from '@/components/engine/EnginePage';
import KpiStrip from '@/components/engine/Kpis';
import {
  CASH_API,
  CashCustomer,
  EnginePage as Page
} from '@/components/engine/api';

function Body({ page }: { page: Page }) {
  const first = page.customers?.rows[0] ?? null;
  const [picked, setPicked] = useState<CashCustomer | null>(null);
  const selected = picked ?? first;
  return (
    <div className="space-y-5">
      {page.kpis?.length ? <KpiStrip kpis={page.kpis} /> : null}
      {page.customers ? (
        <CustomersTable
          customers={page.customers}
          selected={selected}
          onSelect={setPicked}
        />
      ) : null}
      {selected || page.cheques ? (
        <div className="grid gap-4 lg:grid-cols-2 lg:items-start">
          {selected ? <CustomerCard customer={selected} /> : null}
          {page.cheques ? <ChequesCard cheques={page.cheques} /> : null}
        </div>
      ) : null}
      <SectionsGrid page={page} />
    </div>
  );
}

export default function CashEngine() {
  return (
    <EnginePage
      api={CASH_API}
      eyebrow="Cash Signals"
      fallbackTitle="Cash Signals: who owes you and what is coming in"
      render={(page) => <Body page={page} />}
    />
  );
}
